import React from 'react';
import { Box, Text, IconButton, HStack } from '@chakra-ui/react';
import { FaMoon, FaSun } from 'react-icons/fa';
import { useColorMode } from '@chakra-ui/react';
import { useOnboardingChecklist } from './onboarding/OnboardingChecklistProvider';

export default function ThemesCard() {
  const { colorMode, toggleColorMode } = useColorMode();
  const { markThemeSelected } = useOnboardingChecklist();
  const handleToggle = () => {
    toggleColorMode();
    markThemeSelected?.();
  };

  return (
    <Box borderWidth="1px" borderRadius="xl" p={3} mb={4} bg="bg.surface" borderColor="border.subtle">
      <HStack justifyContent="space-between">
        <Text fontSize="lg" fontWeight="bold">Themes</Text>
        <IconButton
          aria-label="Toggle theme"
          icon={colorMode === 'light' ? <FaMoon /> : <FaSun />}
          onClick={handleToggle}
          size="sm"
        />
      </HStack>
    </Box>
  );
}
